import { useFormContext } from "react-hook-form";
import Ic_eye from "../../../../assets/images/eye.png";
import React, { ReactElement, ReactNode, useEffect, useState } from "react";
import Ic_closed_eye from "../../../../assets/images/eye-off.png";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { setMedicalRecord } from "../../../../redux/reducers/medicalRecordSlice";

export const EditableComponent: React.FC<{
  field: any;
  component: ReactNode;
  name: string;
  opacity?: boolean;
  className?: string;
}> = ({ component, field, name, opacity, className = "" }) => {
  const [isNewVisible, setIsNewVisible] = useState<boolean>(field?.IsVisible);

  const child = React.cloneElement(component as ReactElement, {
    disabled: true,
  });

  const { setValue, watch, getValues } = useFormContext();
  const dispatch = useDispatch()
  useEffect(() => {
    setIsNewVisible(watch(name));
  }, [field?.IsVisible, watch(name)]);

  const medicalRecord: any = useSelector(
    (state: RootState) => state.medicalRecord.record,
  );
  const fieldName = field?.Key ?? `Attributes.${String(field?.Id)}`;



  const handleEyeClick = (event: React.MouseEvent, newVisibility: boolean) => {
    event.stopPropagation();
    event.preventDefault();
    setIsNewVisible(newVisibility);
    setValue(name, newVisibility);


    if (!newVisibility) {
      setValue(fieldName, undefined);

      let updatedMedicalRecord = { ...medicalRecord };

      if (fieldName.includes(".")) {
        const [parent, sub] = fieldName.split(".");

        updatedMedicalRecord = {
          ...updatedMedicalRecord,
          [parent]: {
            ...updatedMedicalRecord[parent],
            [sub]: undefined,
          },
        };
      } else {
        updatedMedicalRecord = {
          ...updatedMedicalRecord,
          [fieldName]: undefined,
        };
      }

      dispatch(setMedicalRecord(updatedMedicalRecord));
    }
  };


  return (
    <div
      className={`flex w-full flex-row-reverse items-center gap-2 ${className}`}
    >
      <div
        className={`flex-1 ${!isNewVisible && opacity ? "step-disabled opacity-30" : ""}`}
      >
        {child}
      </div>
      {isNewVisible ? (
        <img
          className="z-10 me-2.5 h-5 w-5 cursor-pointer"
          src={Ic_eye}
          alt="visible"
          onClick={(event) => handleEyeClick(event, false)}
          onMouseDown={(e) => e.stopPropagation()}
        />
      ) : (
        <img
          className="z-10 me-2.5 h-5 w-5 cursor-pointer"
          src={Ic_closed_eye}
          alt="unvisible"
          onClick={(event) => handleEyeClick(event, true)}
          onMouseDown={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
};
